<template>
  <div class="main">
    <svg-icon :width="'80'" :height="'80'" :icon="icon" />
    <h1>{{ title }}</h1>
    <p>{{ description }}</p>
    <div class="buttons">
      <div class="button secondary" @click="onHomepage">Back to Homepage</div>
      <div v-if="getIsLoggedIn" class="button" @click="onMyProjects">
        Go to My Projects
      </div>
      <div v-else class="button" @click="onLogin">Log in / Sign Up</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import SvgIcon from '../all/SvgIcon.vue';

export default {
  components: {
    SvgIcon,
  },
  props: {
    title: {
      type: String,
      default: null,
    },
    description: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
  },

  data() {
    return {
      loginUrl: '/login',
    };
  },

  computed: {
    ...mapGetters('user/account', ['getIsLoggedIn']),
  },

  mounted() {
    console.log(this.$route.query.redirect_url);
    if (this.$route.query.redirect_url) {
      this.loginUrl = `/login?redirect_url=${encodeURIComponent(this.$route.query.redirect_url)}`;
    }
  },

  methods: {
    /**
     * Event handler: user clicks on Homepage button.
     */
    onHomepage() {
      window.location.href = '/';
    },

    /**
     * Event handler: user clicks on My Projects button. This option requires Logged in users
     */
    onMyProjects() {
      this.$router.push({ name: 'workspace-projects' });
    },

    /**
     * Event handler: user clicks on Login / sign up button. This option requires non-logged in users
     */
    onLogin() {
      window.location.href = this.loginUrl;
    },
  },
};
</script>

<style lang="scss" scoped>
.main {
  display: flex;
  flex-flow: column;
  height: 100%;
  background: #2c3233;
  align-items: center;
  justify-content: center;

  .noaccess {
    color: #db841e;
    margin: 0 0 40px 0;
  }

  h1 {
    color: #fff;
    font-weight: 100;
    font-size: 30px;
  }

  p {
    color: #b6bebf;
    font-size: 18px;
    font-weight: 100;
  }
  .buttons {
    margin: 30px 0 0 0;
    .button {
      background: #ea881f;
      border-radius: 3px;
      color: #fff;
      text-transform: uppercase;
      border: none;
      margin: 0 0 0 10px;
      font-size: 15px;
      font-weight: 400;
      padding: 12px 16px;
      cursor: pointer;
      display: inline-block;
      border: 1px solid transparent;
      min-width: 200px;
      text-align: center;

      &.secondary {
        border: 1px solid #fff;
        background: transparent;
        margin: 0 10px 0 0;
      }
    }
  }
}
</style>
